// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vec-card__Card-module--lCafH {
    display: flex;
    flex-direction: column;
    border: 1px solid var(--color-border-default);
    border-radius: var(--radius-md);
    padding: var(--space-md);
}
`, "",{"version":3,"sources":["webpack://./vector/src/Card/Card.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,6CAA6C;IAC7C,+BAA+B;IAC/B,wBAAwB;AAC5B","sourcesContent":[".vec-card {\n    display: flex;\n    flex-direction: column;\n    border: 1px solid var(--color-border-default);\n    border-radius: var(--radius-md);\n    padding: var(--space-md);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"vecCard": `vec-card__Card-module--lCafH`
};
export default ___CSS_LOADER_EXPORT___;
